import React, { Fragment } from 'react'

const Address = ({
    street_address,
    city,
    state,
    setstreet_address,
    setcity,
    setstate,
}) => {
    return (
        <Fragment>
            <div className="bg-white p-6 rounded-xl border border-zinc-200 shadow-sm">
                
                {/* Header */}
                <div className="flex items-center gap-4 mb-6">
                    <div className="w-10 h-10 bg-zinc-900 rounded-lg flex items-center justify-center text-white flex-shrink-0">
                        <i className="fa-solid fa-map text-sm"></i>
                    </div>
                    <div>
                        <h3 className="text-base font-semibold text-zinc-900">Address</h3>
                        <p className="text-xs text-zinc-500">Where are you located?</p>
                    </div>
                </div>

                {/* Street Address */}
                <div className="flex flex-col mb-4">
                    <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">Street Address <span className="text-red-500">*</span></label>
                    <div className="flex border border-zinc-200 rounded-lg overflow-hidden focus-within:border-zinc-900 focus-within:ring-1 focus-within:ring-zinc-900 transition-all">
                        <input
                            type="text"
                            value={street_address}
                            onChange={(e) => setstreet_address(e.target.value)}
                            className="flex-1 px-4 py-2.5 outline-none text-sm text-zinc-800 placeholder-zinc-400 bg-white"
                            placeholder="Enter Street Address"
                        />
                        <div className="flex items-center justify-center px-4 bg-white text-zinc-400">
                            <i className="fa-brands fa-airbnb text-lg"></i>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 gap-4">
                    {/* City */}
                    <div className="flex flex-col">
                        <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">City <span className="text-red-500">*</span></label>
                        <div className="flex border border-zinc-200 rounded-lg overflow-hidden focus-within:border-zinc-900 focus-within:ring-1 focus-within:ring-zinc-900 transition-all">
                            <input
                                type="text"
                                value={city}
                                onChange={(e) => setcity(e.target.value)}
                                className="flex-1 px-4 py-2.5 outline-none text-sm text-zinc-800 placeholder-zinc-400 bg-white"
                                placeholder="City"
                            />
                            <div className="flex items-center justify-center px-4 bg-white text-zinc-400">
                                <i className="fa-regular fa-building text-lg"></i>
                            </div>
                        </div>
                    </div>

                    {/* State */}
                    <div className="flex flex-col">
                        <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">State <span className="text-red-500">*</span></label>
                        <div className="flex border border-zinc-200 rounded-lg overflow-hidden focus-within:border-zinc-900 focus-within:ring-1 focus-within:ring-zinc-900 transition-all">
                            <input
                                type="text"
                                value={state}
                                onChange={(e) => setstate(e.target.value)}
                                className="flex-1 px-4 py-2.5 outline-none text-sm text-zinc-800 placeholder-zinc-400 bg-white"
                                placeholder="State"
                            />
                            <div className="flex items-center justify-center px-4 bg-white text-zinc-400">
                                <i className="fa-regular fa-map text-lg"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Address
